import { createContext, useContext, useState, useEffect } from 'react';
import { useAuth } from './AuthContext';
import api from 'services/api';

const TenantContext = createContext({});

export function TenantProvider({ children }) {
  const { token } = useAuth();
  const [branding, setBranding] = useState(null);

  useEffect(() => {
    if (!token) { setBranding(null); return; }
    api.get('/v1/tenant/branding')
      .then(res => {
        if (res.data?.success) setBranding(res.data.data);
      })
      .catch(() => {});
  }, [token]);

  return (
    <TenantContext.Provider value={branding}>
      {children}
    </TenantContext.Provider>
  );
}

export const useTenant = () => useContext(TenantContext);
